import React, { useEffect, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { useSelector } from "react-redux";
import IndexedDBService, { storeName } from "../../Utils/DBConfig";
import { applyScriptFonts } from "../../services/helperFunction.service";

const TinyTextEditior = ({ getEditorContent, kirtanId, importData, getEditorHtml }) => {
  const [kirtanData, setKirtanData] = useState({});

  const [editorData, setEditorData] = useState("");

  const localTinyMCEScriptSrc = `${process.env.PUBLIC_URL}/tinymce/tinymce.min.js`;

  const isDbInitialized = useSelector((state) => state.db.isDbInitialized);

  useEffect(() => {
    isDbInitialized &&
      IndexedDBService.getAllData(storeName).then((data) => setKirtanData(Object.values(data).find((kirtan) => kirtan.id === Number(kirtanId))));
  }, [isDbInitialized, kirtanId]);

  useEffect(() => {
    if (kirtanData && Object.keys(kirtanData).length > 0) {
      setEditorData(kirtanData.originalContent);
      getEditorContent(kirtanData.originalContent);
    }
  }, [kirtanData]);

  const handleEditorChange = (content, editor) => {
    getEditorHtml(editor.getContent({ format: "html" }));
    getEditorContent(content);
  };

  useEffect(() => {
    if (importData?.length > 5) {
      const processedHtml = applyScriptFonts(importData);

      setEditorData(processedHtml);
      // setEditorData(importData);
    }
  }, [importData]);

  return (
    <>
      <Editor
        tinymceScriptSrc={localTinyMCEScriptSrc}
        init={{
          license_key: "n90tw3sxlkuzpsip6nv3d8b5e5v5qywageetd241hh7eab1w",
          menubar: false,
          toolbar: [
            { name: "history", items: ["undo", "redo"] },
            { name: "fontFamily", items: ["fontFamily"] },
            { name: "formatting", items: ["bold", "italic", "underline"] },
            { name: "forecolor", items: ["forecolor"] },
            { name: "customColors", items: ["redGhanu", "purpleGhanu", "redGyan", "purpleGyan"] },
          ],
          setup: (editor) => {
            // Inject custom CSS for button styling
            editor.on("init", () => {
              const styleEl = document.createElement("style");
              styleEl.innerHTML = `
                button[aria-label="Red-Ghanu"] {
                  background-color: #900000 !important;
                  color: white !important;
                  border: none !important;
                  padding: 4px 8px !important;
                }
                button[aria-label="Red-Ghanu"]:hover {
                  background-color: #b00000 !important;
                }
                button[aria-label="Purple-Ghanu"] {
                  background-color: #0003AA !important;
                  color: white !important;
                  border: none !important;
                  padding: 4px 8px !important;
                }
                button[aria-label="Purple-Ghanu"]:hover {
                  background-color: #2020cc !important;
                }
                button[aria-label="Red-Gyan"] {
                  background-color: #900000 !important;
                  color: white !important;
                  border: none !important;
                  padding: 4px 8px !important;
                }
                button[aria-label="Red-Gyan"]:hover {
                  background-color: #b00000 !important;
                }
                button[aria-label="Purple-Gyan"] {
                  background-color: #0003AA !important;
                  color: white !important;
                  border: none !important;
                  padding: 4px 8px !important;
                }
                button[aria-label="Purple-Gyan"]:hover {
                  background-color: #2020cc !important;
                }
              `;
              document.head.appendChild(styleEl);
            });

            // Red button with Ghanu_unicode_Guj font
            editor.ui.registry.addButton("redGhanu", {
              text: "ગુજ",
              tooltip: "Red-Ghanu",
              onAction: () => {
                editor.formatter.apply("redGhanuFormat");
              },
            });

            // Purple button with Ghanu_unicode_bold_Guj font
            editor.ui.registry.addButton("purpleGhanu", {
              text: "ગુજ",
              tooltip: "Purple-Ghanu",
              onAction: () => {
                editor.formatter.apply("purpleGhanuFormat");
              },
            });

            editor.ui.registry.addButton("redGyan", {
              text: "હિન્દી",
              tooltip: "Red-Gyan",
              onAction: () => {
                editor.formatter.apply("redGyanFormat");
              },
            });

            // Purple button with Ghanu_unicode_bold_Guj font
            editor.ui.registry.addButton("purpleGyan", {
              text: "હિન્દી",
              tooltip: "Purple-Gyan",
              onAction: () => {
                editor.formatter.apply("purpleGyanBoldFormat");
              },
            });

            // Register custom formats
            editor.on("init", () => {
              editor.formatter.register("redGhanuFormat", {
                inline: "span",
                styles: {
                  color: "#900000",
                  fontFamily: "Ghanu_unicode_bold_Guj",
                },
              });

              editor.formatter.register("purpleGhanuFormat", {
                inline: "span",
                styles: {
                  color: "#0003AA",
                  fontFamily: "Ghanu_unicode_bold_Guj",
                },
              });

              editor.formatter.register("redGyanFormat", {
                inline: "span",
                styles: {
                  color: "#900000",
                  fontFamily: "Gyan_Uni_Bold_Hindi",
                },
              });

              editor.formatter.register("purpleGyanBoldFormat", {
                inline: "span",
                styles: {
                  color: "#0003AA",
                  fontFamily: "Gyan_Uni_Bold_Hindi",
                },
              });
            });
          },
          font_family_formats: `
          Guj_Gopika_Two_Bold=ગુજ-ગોપિકા-ટૂ-બોલ્ડ;
          Hin_CC-Devnagri_Bold_SULEKH=હિન-સીસી-દેવનાગરી-બોલ્ડ-સુલેખ;
          AA_Sanskrut_Jodaxar_B_SULEKH=સંસ્કૃત-જોડાક્ષર-બી-સુલેખ;
          Ghanu_unicode_Guj=Ghanu_unicode_Guj;
          Ghanu_unicode_bold_Guj=Ghanu_unicode_bold_Guj;
          Gyan_Uni_Bold_Hindi=Gyan_Uni_Bold_Hindi;
          UH002 SanskritText-Regular=સંસ્કૃત ટેક્સ્ટ-સામાન્ય;
          UH002 SanskritText-Bold=સંસ્કૃત ટેક્સ્ટ-બોલ્ડ;`,
          tinycomments_mode: "embedded",
          tinycomments_author: "Author name",
          mergetags_list: [
            { value: "First.Name", title: "First Name" },
            { value: "Email", title: "Email" },
          ],
          ai_request: (request, respondWith) => respondWith.string(() => Promise.reject("See docs to implement AI Assistant")),
          height: "650px",
          content_style: `
                    @font-face {
                      font-family: "Guj_Gopika_Two_Bold";
                      src: url("./fonts/Guj_Gopika_Two_Bold.ttf") format("truetype");
                    }

                    @font-face {
                      font-family: "Hin_CC-Devnagri_Bold_SULEKH";
                      src: url("./fonts/H-devb_1.ttf") format("truetype");
                    }

                    @font-face {
                      font-family: "AA_Sanskrut_Jodaxar_B_SULEKH";
                      src: url("./fonts/SanjodaB.ttf") format("truetype");
                    }

                    @font-face {
                      font-family: "Ghanu_unicode_Guj";
                      src: url("./fonts/Ghanu-Regular.ttf") format("truetype");
                    }

                    @font-face {
                      font-family: "Ghanu_unicode_bold_Guj";
                      src: url("./fonts/GhanuTest-Bold.ttf") format("truetype");
                    }

                    @font-face {
                      font-family: "Gyan_Uni_Bold_Hindi";
                      src: url("./fonts/Gyan_Uni_Bold.ttf") format("truetype");
                    }

                    @font-face {
                      font-family: "UH002 SanskritText-Regular";
                      src: url("./fonts/UH002\ SanskritText-Regular.ttf") format("truetype");
                    }

                    @font-face {
                      font-family: "UH002 SanskritText-Bold";
                      src: url("./fonts/UH002\ SanskritText-Bold.ttf") format("truetype");
                    }

                    body {
                        font-family: monospace;
                        font-size: 23px;
                    }`,
        }}
        initialValue={editorData}
        onEditorChange={handleEditorChange}
      />
    </>
  );
};
export default TinyTextEditior;
